<template>
  <div>
    <b-modal
      v-model="modalVisible"
      :modal-class="[hideCloseBtn ? 'no_closed_modal' : '', modalXl ? 'modal_xl' : '']"
      :no-close-on-backdrop="hideCloseBtn"
      :no-close-on-esc="hideCloseBtn"
      @hide="modalClose"
    >
      <slot name="title"></slot>
      <slot name="content"></slot>
    </b-modal>
    
  </div>
</template>

<script>
export default {
  name: "Modal",
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    hideCloseBtn: {
      type: Boolean,
      default: false,
    },
    modalXl: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modalVisible: false,
    };
  },
  methods: {
    modalClose() {
      this.$emit("closeModal");
    }
  },
  watch: {
    showModal(newValue) {
      this.modalVisible = newValue;
    }
  }
};
</script>

<style scoped>
:deep(.modal-body) {
  padding-top: 0 !important;
}
:deep(.modal-body h4) {
  text-align: center;
}
:deep(.modal-footer) {
  display: none;
}
:deep(.no_closed_modal .modal-header) {
  display: none !important;
}
:deep(.no_closed_modal .modal-body) {
  padding-top: 24px !important;
}
:deep(.modal_xl .modal-dialog) {
  max-width: 1200px !important;
}
</style>
